<template>
  <div class="chat-container w-100 position-relative mb-5 pb-3">
    <span id="ticket"></span>
    <ticket-activities v-if="getMerchant().merchant_category_name == 'ACTIVITIES'" />
    <ticket-transport v-if="getMerchant().merchant_category_name == 'TRANSPORT'" />
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import TicketActivities from '@/pages/ticket/TicketActivities'
  import TicketTransport from '@/pages/ticket/TicketTransport'

  export default {
    components:{
      TicketActivities,
      TicketTransport
    },
    data() {
      return {

      }
    },
    mounted(){
      document.getElementById('ticket').scrollIntoView({
          behavior: 'smooth'
      });
    },
    methods:{
      // vuex func
      ...mapGetters(['getMerchant']),
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/ticket/TicketList.vue